// removed by extract-text-webpack-plugin
module.exports = {"container":"UpcomingItem__container___3u_re","main":"UpcomingItem__main___NPMVN"};